"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getIntentIcon", {
    enumerable: true,
    get: function() {
        return getIntentIcon;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reacticons = require("@fluentui/react-icons");
function getIntentIcon(intent) {
    switch(intent){
        case 'info':
            return /*#__PURE__*/ _react.createElement(_reacticons.InfoFilled, null);
        case 'warning':
            return /*#__PURE__*/ _react.createElement(_reacticons.WarningFilled, null);
        case 'error':
            return /*#__PURE__*/ _react.createElement(_reacticons.ErrorCircleFilled, null);
        case 'success':
            return /*#__PURE__*/ _react.createElement(_reacticons.CheckmarkCircleFilled, null);
        default:
            return null;
    }
}
